import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { IndexPageDocument } from 'generated/resources/graphql'

import { PortalWrapper } from 'modules/core/components/PortalWrapper'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import type { RouteContext } from 'modules/employees/lib/types'
import { canAccessWelcomeSpace } from 'modules/employees/lib/utils'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import TasksList from 'modules/tasks/components/TasksList'
import { TaskIdentifier } from 'modules/tasks/lib/task'

function IndexComponent() {
  const { employee: currentEmployee } = useCurrentSession()
  const { cardEmployeeRight } = useOutletContext<RouteContext>()
  const { id: employeeIdFromParams } = useParams()

  const employeeId = Number(employeeIdFromParams) || currentEmployee.id

  const { data, loading, error } = useQuery(IndexPageDocument, {
    variables: { employeeId },
  })

  const canManageTasks =
    data?.employees?.employeesConnection?.edges?.[0]?.node?._policies?.manageTasks?.can

  const accessId = data?.employees?.employeesConnection?.edges?.[0]?.node?.access?.id

  const hideActions = canAccessWelcomeSpace(currentEmployee)

  return (
    <ResponsivePage.Body
      variant="full"
      showHeader={false}
      loading={loading}
      error={error}
      authorized={canManageTasks}
    >
      <PortalWrapper container={cardEmployeeRight}></PortalWrapper>
      <TasksList
        involveeId={accessId}
        identifier={TaskIdentifier.Single}
        hideActions={hideActions}
        employeeId={employeeId}
        canManageTasks={canManageTasks}
        isExternalUser={!currentEmployee}
      />
      <Outlet context={{ currentUserId: accessId }} />
    </ResponsivePage.Body>
  )
}

export default IndexComponent
